import styled from "styled-components";
import BREAKPOINTS from "../../Theme/Breakpoints";
import COLORS from "../../Theme/Colors";

export const Wrapper = styled.div`
  padding: 6rem 1rem;
  background: linear-gradient(
    to bottom,
    #ffffff,
    #f1f1f1,
    #f1f1f1,
    #f1f1f1,
    #f1f1f1,
    #f1f1f1
  );

  ${BREAKPOINTS.MOBILE} {
    background: linear-gradient(
      to bottom,
      #f1f1f1,
      #f1f1f1,
      #f1f1f1,
      #f1f1f1,
      #f1f1f1,
      #f1f1f1
    );
  }

  .heading {
    display: flex;
    gap: 0.5rem;
    justify-content: center;
    align-items: center;
    margin-bottom: 2rem;

    h1 {
      margin: 0;
      font-family: "Poppins", sans-serif;
      font-weight: 600;
      font-size: 2rem;
    }

    svg {
      font-size: 2rem;
    }
  }
`;

export const Container = styled.div`
  margin: auto;
  max-width: 1100px;
`;

export const GreetingList = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  ${BREAKPOINTS.TABLET} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${BREAKPOINTS.MOBILE} {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const GreetingItem = styled.div`
  padding: 1.7rem;
  display: flex;
  flex-direction: column;
  border-radius: 1rem;
  margin: 0.7rem;
  background-color: ${COLORS.white};

  &:hover {
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.2);
  }
`;

export const User = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  gap: 0.6rem;
`;

export const Profile = styled.img`
  height: 100%;
  width: 100%;
  max-height: 43px;
  max-width: 43px;
  object-fit: cover;
  border-radius: 50%;
`;

export const Name = styled.div`
  gap: 1px;
  display: flex;
  flex-direction: column;

  h4,
  p {
    margin: 0;
    font-family: "Inter", sans-serif;
  }

  h4 {
    font-weight: 600;
    line-height: 1.2rem;
  }

  p {
    font-size: 12px;
    color: ${COLORS.darkgray};
  }

  .date {
    gap: 4px;
    align-items: center;
    display: flex;

    svg {
      display: flex;
      font-size: 13px;
      color: ${COLORS.darkgray};
    }
  }
`;

export const Message = styled.div`
  display: flex;
  flex-direction: column;

  p {
    margin: 0;
    padding: 0.5rem 0;
    line-height: 1.4rem;

    img,
    video,
    iframe {
      display: flex;
      width: 100%;
      height: auto;
      object-fit: cover;
      border-radius: 0.6rem;
    }
  }
`;

export const IconContainer = styled.div`
  margin-left: auto;
  margin-top: auto;
  display: flex;
  cursor: pointer;

  .icon {
    font-size: 21px;
    color: ${COLORS.red};

    ${BREAKPOINTS.MOBILE} {
      font-size: 24px;
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

export const Button = styled.button`
  background-color: ${COLORS.blue};
  color: ${COLORS.white};
  border: none;
  border-radius: 2rem;
  padding: 0.7rem 1.5rem;
  cursor: pointer;
  font-size: 0.8rem;
  font-family: "Poppins", sans-serif;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${COLORS.darkblue};
  }
`;
